
const FrontendFooter = () => {
  return (
    <footer id="footer" className="footer position-relative dark-background">

      <div className="container">
        <div className="copyright text-center ">
          <p>© <span>Copyright</span> <span>All Rights Reserved</span></p>
        </div>
        <div className="credits">
          Designed by <a href="https://stechworld.com/" target="blank">STech World</a>
        </div>
      </div>

    </footer>
  )
}
export default FrontendFooter
